import styled from 'styled-components'
import { TRIAL, MONTH, YEAR } from '../../utils/stripePrices'

type Props = {
  plan?: string;
  hasDiscount?: boolean;
}

const StyledAccountSubscriptionCard = styled.div<Props>`
  .subscription-card {
    margin: 0 8px;
    border: 1px solid #797978;
    box-sizing: border-box;
    border-radius: 3px;

    .card-gradient {
      height: 17px;

      ${({ plan }) => {
    switch (plan) {
      case MONTH:
        return `background: linear-gradient(135deg, rgba(249, 225, 180, 0.4) 2.88%, rgba(182, 224, 245, 0.4) 100%);`
      case YEAR:
        return `background: linear-gradient(135deg, rgba(255, 172, 198, 0.4) 2.88%, rgba(182, 224, 245, 0.4) 100%);`
      case TRIAL:
        return `background: #EBEBEB;`
    }
  }}
    }

    .card-content {
      position: relative;
      font-family: ${({ theme }) => theme.fonts.nunito};
      padding: ${({ plan }) => (plan !== YEAR ? '60px 30px' : '20px 30px 50px 30px')};

      .most-popular {
        font-weight: 700;
        font-size: 13px;
        color: ${({ theme }) => theme.colors.gray[700]};

        border-radius: 3px;
        display: inline-flex;
        padding: 6px 30px;
        margin-bottom: 12px;
        background: linear-gradient(
          135deg,
          rgba(255, 172, 198, 0.4) 2.88%,
          rgba(182, 224, 245, 0.4) 100%
        );
      }

      .card-header {
        margin-bottom: 20px;

        .card-header-main {
          color: ${({ theme }) => theme.colors.gray[700]};
          display: flex;
          align-items: start;
          justify-content: space-between;
        }

        .card-title,
        .price {
          font-family: ${({ theme }) => theme.fonts.lexend};
          font-weight: 400;
          font-size: 20px;
        }

        .interval {
          font-weight: 300;
          font-size: 14px;
        }

        .original-price {
          text-decoration: ${({ hasDiscount }) => (hasDiscount ? 'line-through' : 'none')};
        }

        .slashed-price {
          margin-left: 8px;
          text-decoration: line-through;
          font-weight: 300;
          color: ${({ theme }) => theme.colors.green[500]};
        }

        .price-sale-description {
          color: ${({ theme }) => theme.colors.gray[500]};
          font-size: 13px;
          font-family: ${({ theme }) => theme.fonts.nunito};
          font-weight: 600;
          text-align: right;
          margin-left: auto;
          margin-top: 4px;
          display: block;
        }

        .discounted {
          display: flex;
          justify-content: flex-end;
          align-items: flex-end;

          margin-top: 5px;
          color: ${({ theme }) => theme.colors.green[400]};
          font-size: 20px;

          .interval {
            margin-left: 5px;
          }
        }
      }

      .subscription-description {
        font-weight: 600;
        font-size: 14px;
        line-height: 22px;
        color: ${({ theme }) => theme.colors.gray[500]};
        padding-bottom: ${({ plan }) => (TRIAL === plan ? '0' : '20px')};
      }

      .list-header {
        font-weight: 700;
        color: ${({ theme }) => theme.colors.gray[700]};
        font-size: 14px;
        margin: 0 0 20px 0;
      }

      ul {
        list-style-type: none;
        padding-left: 0;
        font-weight: 600;

        li {
          display: flex;
          line-height: 24px;
          color: ${({ theme }) => theme.colors.gray[700]};
          font-size: 14px;

          svg {
            height: 20px;
            margin-right: 12px;
            flex-shrink: 0;
            position: relative;
            top: 1px;
          }
        }

        li:not(:last-child) {
          padding-bottom: 8px;
        }
      }
    }
  }

  .button-container {
    padding-top: 28px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    button {
      background: transparent;
      white-space: nowrap;
      font-size: 16px;
    }

    button.read-more {
      display: flex;
      line-height: 40px;
      margin-bottom: 5px;

      border: none;
      font-family: ${({ theme }) => theme.fonts.nunito};
      color: ${({ theme }) => theme.colors.gray[400]};
      font-weight: 400;
      padding: 0;

      svg {
        height: 20px;
        flex-shrink: 0;
        position: relative;
        bottom: 1px;
        top: 10px;
        margin-left: 10px;
      }
    }

    .select {
      font-family: ${({ theme }) => theme.fonts.lexend};
      color: ${({ theme }) => theme.colors.gray[700]};
      text-transform: uppercase;
      font-weight: 500;
      letter-spacing: 1px;
      font-size: 16px;

      padding: 14.5px 39.5px;
      border: 1px solid #2e3039;
      border-radius: 3px;
    }

    .unsubscribe {
      font-family: ${({ theme }) => theme.fonts.lexend};
      font-weight: 400;
      font-size: 14px;
      letter-spacing: 1px;
      border: none;
      color: ${({ theme }) => theme.colors.gray[400]};
    }
  }
`

export default StyledAccountSubscriptionCard
